import { BaseController } from '../../../../../../../common/base/controller';
import { MODEL_FIELDS } from '../../confirmWarrant.model';

export class PreviousAccountOptionsController extends BaseController {
  constructor($scope, $compile, controllerService) {
    'ngInject';
    super({
      $scope,
      $compile,
      controllerService,
    });
  }

  getLabelFor(field) {
    return `${this.translatePrefix}.${field}`;
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;

    this.accountCloseDeadlineMessages = {
      parse: `${this.translatePrefix}.error.dateInvalid`,
      required: `${this.translatePrefix}.error.required.${this.MODEL_FIELDS.accountCloseDeadline}`,
    };
  }
}
